module.exports = __webpack_public_path__ + "static/thermal-205a60cfc93c045c5be372db35b35eea.jpg";